import React from "react";
import { Check } from "lucide-react";
import { STEP_LABELS } from "./config";

// R5 — extraído MECANICAMENTE de pages/NewOperation.jsx (JSX verbatim; o
// estado vive no componente-pai e chega por `ctx`).
export default function WizardStepper({ ctx }) {
  const {
    step,
    stepFlow,
  } = ctx;
  return (
    <ol className="flex items-center gap-2">
      {stepFlow.map((key, i) => {
        const id = i + 1;
        const active = step === id;
        const done = step > id;
        return (
          <li key={key} className="flex items-center gap-2 flex-1">
            <div
              className={`h-8 w-8 rounded-full border flex items-center justify-center text-[12px] font-semibold transition-colors
                  ${active ? "border-[#0055FF] bg-[#0055FF] text-white" : ""}
                  ${done ? "border-[#0055FF] bg-[#0055FF]/10 text-[#0055FF]" : ""}
                  ${!active && !done ? "border-[var(--zemo-border)] text-zinc-400 bg-white" : ""}
                `}
              data-testid={`step-indicator-${id}`}
            >
              {done ? <Check className="h-4 w-4" /> : id}
            </div>
            <div className={`text-[13px] font-medium ${active ? "text-zinc-900" : "text-zinc-500"} hidden sm:block`}>
              {STEP_LABELS[key]}
            </div>
            {i < stepFlow.length - 1 && (
              <div className={`flex-1 h-px ${done ? "bg-[#0055FF]" : "bg-[var(--zemo-border)]"} mx-2`} />
            )}
          </li>
        );
      })}
    </ol>
  );
}
